import React, { Fragment, useEffect, useMemo, useState, memo } from 'react';
import {
  Marker,
  Polygon,
  InfoWindow,
  Polyline,
} from '@react-google-maps/api';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import {
  Close,
  Person,
  Room,
  TrendingFlat,
  AirlineSeatIndividualSuite,
  ExitToApp,
} from '@material-ui/icons';
import { Button, IconButton, ListItemIcon, ListItemText } from '@material-ui/core';
import { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';

const SelectedSellerRender = memo(function (props) {
  const { setCurrentGps, setMapCenter, setInfoWindowData } = props;
  const { selectedSeller, filteredRoutes } = props;
  return (
    <Fragment>
      <div
        style={{ display: 'flex', flexDirection: 'row', overflowY: 'auto', marginBottom: '5px' }}
      >
        {filteredRoutes.map((route) => {
          return (
            <div
              key={route.id}
              style={{
                maxWidth: '200px',
                marginRight: '10px',
                border: '1px black solid',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
              onClick={() => {
                setMapCenter(route.centroid);
                setInfoWindowData({
                  ...route.centroid,
                  title: route.description,
                  description: route.code,
                });
              }}
            >
              <span>{route.description}</span>
              <div style={{ display: 'flex' }}>
                <Typography variant="caption" style={{ marginRight: '3px' }}>
                  ({route.code})
                </Typography>
                <LayerColorIcon layer={route.layer} />
                <IconButton size="small" color="primary" style={{ padding: 0 }}>
                  <TrendingFlat fontSize="small" />
                </IconButton>
              </div>
            </div>
          );
        })}
      </div>

      {/* Tiempo inactivo */}
      {selectedSeller.inactive_time.length > 0 && (
        <>
          <div>
            <Typography variant="subtitle2">Tiempo inactivo:</Typography>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              overflowY: 'auto',
              marginBottom: '5px',
            }}
          >
            {selectedSeller.inactive_time.map((time) => {
              return (
                <div
                  key={time.min_gps_id}
                  style={{
                    maxWidth: '200px',
                    marginRight: '10px',
                    border: '1px black solid',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    let gps = selectedSeller.gps.find(
                      (gps) => gps.id === parseInt(time.min_gps_id),
                    );
                    if (gps === undefined) {
                      window.alert('No se encontró el gps, amplíe los minutos de búsqueda');
                      return;
                    }
                    let gpsData = {
                      lat: parseFloat(gps.latitude),
                      lng: parseFloat(gps.longitude),
                    };
                    setCurrentGps(gpsData);
                    setMapCenter(gpsData);
                  }}
                >
                  {time.minutes} Minutos
                  <br />
                  De {moment(time.min_created_at).format('LT')} a{' '}
                  {moment(time.max_created_at).format('LT')}
                </div>
              );
            })}
          </div>
        </>
      )}
      {/* Tiempo fuera de ruta */}
      {selectedSeller.out_route_time.length > 0 && (
        <>
          <div>
            <Typography variant="subtitle2">Tiempo fuera de ruta:</Typography>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              overflowY: 'auto',
              marginBottom: '5px',
            }}
          >
            {selectedSeller.out_route_time.map((time) => {
              return (
                <div
                  key={time.min_gps_id}
                  style={{
                    maxWidth: '200px',
                    marginRight: '10px',
                    border: '1px black solid',
                    borderRadius: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    let gps = selectedSeller.gps.find(
                      (gps) => gps.id === parseInt(time.min_gps_id),
                    );
                    if (gps === undefined) {
                      window.alert('No se encontró el gps, amplíe los minutos de búsqueda');
                      return;
                    }
                    let gpsData = {
                      lat: parseFloat(gps.latitude),
                      lng: parseFloat(gps.longitude),
                    };
                    setCurrentGps(gpsData);
                    setMapCenter(gpsData);
                  }}
                >
                  {time.minutes} Minutos
                  <br />
                  De {moment(time.min_created_at).format('LT')} a{' '}
                  {moment(time.max_created_at).format('LT')}
                </div>
              );
            })}
          </div>
        </>
      )}

      <List
        style={{
          height: '500px',
          overflow: 'auto',
        }}
      >
        {selectedSeller.gps.map((gps) => {
          return (
            <ListItem
              button
              key={gps.id}
              onClick={() => {
                let gpsData = {
                  lat: parseFloat(gps.latitude),
                  lng: parseFloat(gps.longitude),
                };
                setCurrentGps(gpsData);
                setMapCenter(gpsData);
              }}
            >
              <ListItemIcon>
                <Room />
              </ListItemIcon>
              <ListItemText
                secondary={
                  <Typography variant="caption">
                    Lat: {gps.latitude} Lng: {gps.longitude}
                  </Typography>
                }
              >
                {moment(gps.created_at).format('LT')}
              </ListItemText>
            </ListItem>
          );
        })}
      </List>
    </Fragment>
  );
});

function TrackingMap(props) {
  const { sellers, routes } = props;
  const [selectedSeller, setSelectedSeller] = useState();

  const [infoWindowData, setInfoWindowData] = useState();
  const [mapZoom, setMapZoom] = useState(14);
  const [mapCenter, setMapCenter] = useState({
    lat: -14.07543457346045,
    lng: -75.73423487506565,
  });

  const [currentGps, setCurrentGps] = useState();

  const filteredRoutes = useMemo(() => {
    if (routes.length === 0) return routes;
    if (selectedSeller === undefined) return routes;
    return routes.filter((route) => {
      let routeIds = selectedSeller.routes.map((routeId) => parseInt(routeId));
      return routeIds.includes(route.id);
    });
  }, [routes, selectedSeller]);

  // Centrar mapa
  useEffect(() => {
    if (routes.length > 0) {
      setMapCenter(routes[0].centroid);
    }
  }, [routes]);

  // Resetear vendedor seleccionado
  useEffect(() => {
    if (sellers.length === 0) {
      setSelectedSeller(undefined);
    }
  }, [sellers]);

  return (
    <GridContainer>
      <GridItem xs={12} md={8}>
        <GoogleMapCustom
          mapContainerStyle={{
            width: '100%',
            height: '700px',
          }}
          zoom={mapZoom}
          center={mapCenter}
          options={{
            disableDoubleClickZoom: true,
          }}
        >
          {/* InfoWindow */}
          {infoWindowData !== undefined && (
            <InfoWindow
              position={{
                lat: parseFloat(infoWindowData.lat),
                lng: parseFloat(infoWindowData.lng),
              }}
              onCloseClick={() => setInfoWindowData(undefined)}
              options={{
                pixelOffset: {
                  width: 0,
                  height: -25,
                },
              }}
            >
              <div>
                <h4>{infoWindowData.title}</h4>
                <h5>{infoWindowData.description}</h5>
              </div>
            </InfoWindow>
          )}

          {/* Gps seleccionado */}
          {currentGps !== undefined && <Marker position={currentGps} icon="/img/point.png" />}

          {/* Marcador de vendedor seleccionado */}
          {selectedSeller !== undefined && selectedSeller.gps.length > 0 && (
            <Fragment>
              <Marker
                position={{
                  lat: parseFloat(selectedSeller.gps[0].latitude),
                  lng: parseFloat(selectedSeller.gps[0].longitude),
                }}
                options={{
                  label: {
                    color: 'white',
                    className: 'map-label',
                    text: selectedSeller.SlpName,
                  },
                }}
              />
              <Polyline
                path={selectedSeller.gps
                  .filter((gps) => gps.latitude !== '0.0')
                  .map((gps) => {
                    return {
                      lat: parseFloat(gps.latitude),
                      lng: parseFloat(gps.longitude),
                    };
                  })}
                options={{
                  strokeColor: '#b200ff',
                  strokeOpacity: 0.5,
                  strokeWeight: 3,
                  visible: true,
                }}
              />
            </Fragment>
          )}

          {/* Marcador de todos los vendedores */}
          {selectedSeller === undefined &&
            sellers.map((seller) => {
              if (seller.gps.length === 0) return undefined;
              let firstGps = seller.gps.find((gps) => gps.latitude !== '0.0') || seller.gps[0];
              return (
                <Fragment key={seller.id}>
                  <Marker
                    position={{
                      lat: parseFloat(firstGps.latitude),
                      lng: parseFloat(firstGps.longitude),
                    }}
                    options={{
                      label: {
                        color: 'white',
                        className: 'map-label',
                        text: seller.SlpName,
                      },
                    }}
                    onClick={() => {
                      if (seller.gps.length > 0) {
                        setMapCenter({
                          lat: parseFloat(seller.gps[0].latitude),
                          lng: parseFloat(seller.gps[0].longitude),
                        });
                      }
                      setSelectedSeller(seller);
                    }}
                  />
                  {/* <Polyline
                    path={seller.gps
                      .filter((gps) => gps.latitude !== '0.0')
                      .map((gps) => {
                        return {
                          lat: parseFloat(gps.latitude),
                          lng: parseFloat(gps.longitude),
                        };
                      })}
                    options={{
                      strokeColor: '#b200ff',
                      strokeOpacity: 0.5,
                      strokeWeight: 3,
                      visible: true,
                    }}
                  /> */}
                </Fragment>
              );
            })}

          {filteredRoutes.map((route) => {
            return (
              <Polygon
                key={route.id}
                path={route.geometry}
                options={{
                  fillColor: route.layer.color,
                }}
              />
            );
          })}
        </GoogleMapCustom>
      </GridItem>
      <GridItem xs={12} md={4}>
        <List>
          {sellers.map((seller) => {
            if (selectedSeller !== undefined && selectedSeller.id !== seller.id) {
              return undefined;
            }
            return (
              <ListItem
                button
                key={seller.id}
                style={{
                  ...(selectedSeller !== undefined && selectedSeller.id === seller.id
                    ? {
                        border: '5px black solid',
                        borderRadius: '5px',
                      }
                    : {}),
                }}
                onClick={() => {
                  if (seller.id === selectedSeller?.id) {
                    if (routes.length > 0) {
                      setMapCenter(routes[0].centroid);
                    }
                    return setSelectedSeller(undefined);
                  }
                  if (seller.gps.length > 0) {
                    setMapCenter({
                      lat: parseFloat(seller.gps[0].latitude),
                      lng: parseFloat(seller.gps[0].longitude),
                    });
                  }
                  setSelectedSeller(seller);
                }}
                disabled={seller.gps.length === 0}
              >
                <ListItemIcon>
                  <Person />
                </ListItemIcon>
                <ListItemText>
                  {seller.SlpName}
                  <br />
                  <Typography variant="caption">
                    {seller.routes.length} {seller.routes.length === 1 ? 'ruta' : 'rutas'}
                  </Typography>
                  <Typography variant="caption" style={{ marginLeft: '10px' }}>
                    {seller.gps.length === 0 && 'Sin gps disponible'}
                  </Typography>
                </ListItemText>

                {seller.inactive_time.length > 0 && (
                  <ListItemIcon>
                    <AirlineSeatIndividualSuite color="error" />
                  </ListItemIcon>
                )}

                {seller.out_route_time.length > 0 && (
                  <ListItemIcon>
                    <ExitToApp color="error" />
                  </ListItemIcon>
                )}
                {seller.id === selectedSeller?.id && (
                  <Button>
                    <Close />
                  </Button>
                )}
              </ListItem>
            );
          })}
        </List>

        {selectedSeller !== undefined && (
          <SelectedSellerRender
            setMapCenter={setMapCenter}
            setCurrentGps={setCurrentGps}
            setInfoWindowData={setInfoWindowData}
            selectedSeller={selectedSeller}
            filteredRoutes={filteredRoutes}
          />
        )}
      </GridItem>
    </GridContainer>
  );
}

export default TrackingMap;
